const e = "FavoritesService";
export {
  e as FAVORITES_SERVICE
};
